// components/CMS/StatisticsCards.js
import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"

const StatisticsCards = () => {
  return (
    <div className="w-full px-6 md:px-px1_l xl:px-px1_xl mt-8 md:mt-[80px] mb-[60px] md:mb-[80px] lg:mb-[120px] xl:mb-[150px]">
      <div className="flex flex-col md:flex-row w-full max-w-[500px] md:max-w-[800px] lg:max-w-[900px] xl:max-w-w2_xl 2xl:max-w-[1350px] gap-y-6 mx-auto">
        <CMSRender
          contentType="StatisticsCardGroup"
          match={{ "content.id": "MainStatisticsBanner" }}
          renderItem={(group) => {
            return group.cards.map((stat, id) => (
              <div
                key={id}
                className="relative md:w-1/4 flex md:flex-col items-center gap-4 md:px-2"
              >
                <div className="flex md:flex-col md:h-[110px] lg:h-[160px] items-center justify-between gap-2">
                  <img
                    src={stat.icon}
                    alt={stat.label}
                    className="w-5 h-5 md:w-10 md:h-10 text-primary"
                  />

                  <Typography 
                    className="text-primary text-base lg:text-[28px] xl:text-[32px] my-0 font-black"
                  >
                    {stat.title}
                  </Typography>

                  <Typography 
                    variant="info_16_medium"
                    className="md:h-9 text-primary text-center uppercase my-0 text-sm"
                  >
                    {stat.info}
                  </Typography>
                </div>

                {id < group.cards?.length - 1 && (
                  <div className="absolute hidden md:block md:h-[56px] lg:h-[96px] right-0 top-0 translate-y-1/2 md:border-r md:border-primary" />
                )}
              </div>
            ))
          }}
        />
      </div>
    </div>
  )
}

export default StatisticsCards

export const AldooComponent = {
  id: 'StatisticsCards',
  component: StatisticsCards,
  meta: {
    name: 'Statistics Cards',
    description: 'Displays a group of statistics cards with icons, numbers, and labels',
    category: 'Marketing',
  },
}
